export { default } from '@/shared/components/CopyText';
export type { CopyTextProps } from '@/shared/components/CopyText';
